<template>
  <div>
    <multiselect
      v-model="selectedAgent"
      placeholder="Начните вводить ФИО или ID агента..."
      select-label=""
      label="text"
      track-by="value"
      :options="filteredAgents"
      :hide-selected="true"
      :loading="loading"
      :disabled="disabled"
      :searchable="true"
      :internal-search="true"
      :custom-label="formatAgentLabel"
    >
      <template slot="option" slot-scope="props">
        <div class="agent-option">
          <div class="agent-name">
            <strong>{{ props.option.text }}</strong>
            <span class="agent-id">ID: {{ props.option.value }}</span>
          </div>
          <div v-if="props.option.corp_email" class="agent-email">
            <i class="fas fa-envelope mr-1"></i>
            <span>{{ props.option.corp_email }}</span>
          </div>
          <div v-else class="agent-email text-muted">
            <i class="fas fa-envelope-slash mr-1"></i>
            <span>Почта не привязана</span>
          </div>
        </div>
      </template>
      <span slot="noResult">Ничего не найдено. Попробуйте снова...</span>
      <span slot="noOptions">Список пуст</span>
    </multiselect>
  </div>
</template>

<script>
import { API_USERS, API_AGENT_CORP_MAIL } from '@/constants';

export default {
  name: 'SelectAgentWithCorpMail',
  props: {
    selected: {
      type: [String, Number],
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      agents: [],
      corpMails: [],
      selectedAgent: null,
      loading: false
    };
  },
  computed: {
    filteredAgents() {
      return this.agents;
    }
  },
  watch: {
    selectedAgent(agent) {
      if (agent) {
        this.$emit('set', agent.value);
      } else {
        this.$emit('set', null);
      }
    },
    selected(value) {
      if (value !== null && value !== undefined) {
        const found = this.agents.find(agent => agent.value === value);
        this.selectedAgent = found || null;
      } else {
        this.selectedAgent = null;
      }
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        // Загружаем агентов
        const usersResponse = await api.call('get', API_USERS + '?roles=agent&withoutFired=true');
        this.agents = usersResponse.data || [];

        // Загружаем корпоративные почты
        const corpMailResponse = await api.call('get', API_AGENT_CORP_MAIL);
        this.corpMails = corpMailResponse.data.data || [];

        // Объединяем данные: добавляем информацию о корпоративной почте к каждому агенту
        // Также добавляем ID в текст для поиска по ID
        this.agents = this.agents.map(agent => {
          const corpMail = this.corpMails.find(mail => mail.user_id === agent.value);
          return {
            ...agent,
            text: `${agent.text} (ID: ${agent.value})`, // Добавляем ID в текст для поиска
            corp_email: corpMail ? corpMail.corp_email : null
          };
        });

        // Инициализируем выбранное значение
        if (this.selected !== null && this.selected !== undefined) {
          const found = this.agents.find(agent => agent.value === this.selected);
          this.selectedAgent = found || null;
        }
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
        this.$toast.error('Не удалось загрузить список агентов');
      } finally {
        this.loading = false;
      }
    },
    formatAgentLabel(option) {
      if (!option) return '';
      // ID уже включен в text, поэтому просто добавляем почту если есть
      let label = option.text;
      if (option.corp_email) {
        label += ` - ${option.corp_email}`;
      }
      return label;
    }
  }
};
</script>

<style scoped>
.agent-option {
  padding: 8px 0;
}

.agent-name {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.agent-id {
  font-size: 0.85em;
  color: #6c757d;
  font-weight: normal;
}

.agent-email {
  font-size: 0.9em;
  margin-top: 4px;
  display: flex;
  align-items: center;
}

.agent-email i {
  font-size: 0.85em;
}
</style>

